import { LocalStorageDataModel } from "../../constants/local-storage-data-model";
import { Env } from "../../utils/globalUtilities";
import axios from "axios";
const unauthorizedCode = [401];

export const PremiumBaseService = axios.create({
  timeout: 60000,
  baseURL: Env().REACT_APP_NODE_PREMIUM_URL,
});
PremiumBaseService.interceptors.request.use(
  (config: any) => {
    const token = localStorage.getItem("TaxmannAuthorization");
    let machineid = localStorage.getItem("machineId");
    config.headers = {
      refreshtoken: sessionStorage.getItem('refreshToken') || '',
      [LocalStorageDataModel.MACHINE_ID]: machineid
    };
    if (token) {
      config.headers = {
        ...config.headers,
        // machineid: machineid,
        taxmannauthorization: token,
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

PremiumBaseService.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    if (response && unauthorizedCode.includes(response.status)) {
      // logoutUserSession()
    }
    return Promise.reject(error);
  }
);
